import { PlayOutlineIcon } from 'assets/icons';
import styles from './view-button.module.scss';

interface ViewButtonProps {
  onClick: () => void;
}

// The top-bar "View" button, sitting just left of the "New" menu. Opens the
// memory player: the current album's inside an album, otherwise the whole
// vault's (see VaultTopBar).
export const ViewButton = ({ onClick }: ViewButtonProps) => (
  <button
    type="button"
    className={styles.viewButton}
    onClick={onClick}
    aria-label="View"
  >
    <span className={styles.label}>View</span>
    <PlayOutlineIcon />
  </button>
);
